<div class="project-risks-page">
  <div class="page-header">
    <div>
      <p class="eyebrow">Project Control Desk</p>
      <h2>Risks & Issues</h2>
      <p class="subtitle">Capture delivery threats early, assign owners, and track mitigation before they become blockers.</p>
    </div>
    <div class="header-actions">
      <label class="project-picker">
        <span>Project</span>
        <select [(ngModel)]="selectedProjectId" (ngModelChange)="loadProjectRisks()">
          <option [ngValue]="null">Select project</option>
          <option *ngFor="let project of projects" [ngValue]="project.id">{{ project.name }}</option>
        </select>
      </label>
      <button mat-stroked-button (click)="loadContext()">Refresh</button>
    </div>
  </div>

  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

  <ng-container *ngIf="selectedProject as project; else emptyState">
    <section class="stats-grid">
      <article class="stat-card" [ngClass]="item.tone" *ngFor="let item of stats">
        <span>{{ item.label }}</span>
        <strong>{{ item.value }}</strong>
      </article>
    </section>

    <section class="workspace-grid">
      <article class="form-panel">
        <div class="panel-head form-head">
          <div class="form-heading">
            <span class="form-kicker">Risk Intake</span>
            <h3>{{ editingRiskId ? 'Update Risk' : 'Register New Risk' }}</h3>
            <p>{{ project.name }}</p>
          </div>
          <button mat-button *ngIf="editingRiskId" (click)="resetForm()">New Entry</button>
        </div>

        <div class="form-grid">
          <label class="full">
            <span>Title</span>
            <input [(ngModel)]="form.title" type="text" placeholder="Delayed vendor delivery, approval bottleneck, scope creep">
          </label>

          <label>
            <span>Owner</span>
            <select [(ngModel)]="form.ownerStaffId">
              <option [ngValue]="null">Unassigned</option>
              <option *ngFor="let staff of staffs" [ngValue]="staff.id">{{ staff.fullName }}</option>
            </select>
          </label>

          <label>
            <span>Severity</span>
            <select [(ngModel)]="form.severity">
              <option *ngFor="let severity of severityOptions" [value]="severity">{{ severity }}</option>
            </select>
          </label>

          <label>
            <span>Status</span>
            <select [(ngModel)]="form.status">
              <option *ngFor="let status of statusOptions" [value]="status">{{ status }}</option>
            </select>
          </label>

          <label>
            <span>Target Resolution</span>
            <input [(ngModel)]="form.targetResolutionDate" type="date">
          </label>

          <label>
            <span>Current State</span>
            <input [value]="form.status + ' • ' + form.severity" type="text" readonly>
          </label>

          <label class="full">
            <span>Notify Staff</span>
            <select multiple [(ngModel)]="form.mentionedStaffIds">
              <option *ngFor="let staff of staffs" [ngValue]="staff.id">{{ staff.fullName }}</option>
            </select>
          </label>

          <label class="full">
            <span>Description</span>
            <textarea [(ngModel)]="form.description" rows="4" placeholder="Describe the threat, cause, and possible impact on project delivery."></textarea>
          </label>

          <label class="full">
            <span>Mitigation Plan</span>
            <textarea [(ngModel)]="form.mitigationPlan" rows="4" placeholder="State what action is being taken, by whom, and what outcome is expected."></textarea>
          </label>
        </div>

        <div class="form-actions">
          <button mat-flat-button color="primary" (click)="saveRisk()" [disabled]="saving">
            {{ saving ? 'Saving...' : (editingRiskId ? 'Update Risk' : 'Save Risk') }}
          </button>
          <button mat-stroked-button type="button" (click)="resetForm()">Clear</button>
        </div>
      </article>

      <article class="list-panel">
        <div class="panel-head">
          <h3>Risk Register</h3>
          <div class="filters">
            <input [(ngModel)]="search" type="text" placeholder="Search register">
            <select [(ngModel)]="statusFilter">
              <option value="all">All Statuses</option>
              <option *ngFor="let status of statusOptions" [value]="status.toLowerCase()">{{ status }}</option>
            </select>
            <select [(ngModel)]="severityFilter">
              <option value="all">All Severities</option>
              <option *ngFor="let severity of severityOptions" [value]="severity.toLowerCase()">{{ severity }}</option>
            </select>
          </div>
        </div>

        <div class="risk-list" *ngIf="filteredRisks.length; else noRisks">
          <button class="risk-card" type="button" *ngFor="let risk of filteredRisks" (click)="selectRisk(risk)">
            <div class="risk-top">
              <span class="severity" [ngClass]="(risk.severity || '').toLowerCase()">{{ risk.severity }}</span>
              <span class="status" [ngClass]="(risk.status || '').toLowerCase()">{{ risk.status }}</span>
            </div>
            <h4>{{ risk.title }}</h4>
            <p>{{ risk.description || 'No description provided.' }}</p>
            <div class="risk-meta">
              <span>Owner: {{ risk.ownerStaffName || 'Unassigned' }}</span>
              <span [ngClass]="{ late: isLate(risk) }">
                Due: {{ risk.targetResolutionDate ? (risk.targetResolutionDate | date:'mediumDate') : 'Not set' }}
              </span>
              <span>Updated: {{ risk.updatedAt | date:'mediumDate' }}</span>
            </div>
          </button>
        </div>
      </article>
    </section>
  </ng-container>
</div>

<ng-template #emptyState>
  <section class="empty-state">
    <mat-icon>warning</mat-icon>
    <h3>No project selected</h3>
    <p>Select a project to open its risk register.</p>
  </section>
</ng-template>

<ng-template #noRisks>
  <div class="empty-register">
    <mat-icon>playlist_add_check</mat-icon>
    <h3>No risks logged</h3>
    <p>The register is clear. Add the first risk or issue for this project.</p>
  </div>
</ng-template>
